import Charts from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { CryptoAnnotationsHeading } from "../../../Constant";
import { ANNOTATION_DATA } from "../../../Data/Widgets/ChartWidgets";

const CryptoAnnotations = () => {
  return (
    <Col xl="6" lg="12" className="xl-50">
      <Card>
        <CommonCardHeader title={CryptoAnnotationsHeading} className="border-bottom-1" />
        <CardBody>
          <div className="chart-container">
            <Row>
              <Col xs="12">
                <div id="crypto-annotation">
                  <Charts options={ANNOTATION_DATA} series={ANNOTATION_DATA.series} height={400} type="line"/>
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CryptoAnnotations;
